import { render, staticRenderFns } from "./UserSquareAvatar.vue?vue&type=template&id=518a34a4&"
import script from "./UserSquareAvatar.vue?vue&type=script&lang=js&"
export * from "./UserSquareAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports